import styled from 'styled-components';
import { Button } from 'components/elements';
import { colors } from 'settings/style';

/** Search field + button always on one row; width comes from parent (toolbar slot or sidebar). */
export const SearchBarWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: stretch;
  gap: 12px;
  width: 100%;
  min-width: 0;
  margin-bottom: 0;
  font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', sans-serif;
`;

export const SearchBarInputWrapper = styled.div`
  flex: 1;
  min-width: 0;
  border-radius: 10px;
  display: flex;
  align-items: center;
  gap: 10px;
  background: #fff;
  border: 1px solid #e4e7ec;
  padding: 0 16px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;

  &:focus-within {
    border-color: #1a2744;
    box-shadow: 0 0 0 3px rgba(26, 39, 68, 0.18);
  }

  .icon-search {
    flex-shrink: 0;
    font-size: 16px;
    color: #667085;
  }

  input,
  .ant-input {
    background: transparent;
    border: none;
    outline: none;
    font-size: 0.9375rem;
    color: ${colors.grey900};
    font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', sans-serif;

    &:focus,
    &.ant-input-focused {
      border: none;
      box-shadow: none;
      outline: none;
    }

    &::placeholder {
      color: #98a2b3;
    }
  }
`;

export const ExploreSearchButton = styled(Button)`
  flex-shrink: 0;
  min-height: 40px;
  padding: 0px 12px !important;
  border-radius: 10px;
  border: none !important;
  font-family: 'Inter', system-ui, -apple-system, 'Segoe UI', sans-serif;
  font-weight: 600 !important;
  font-size: 0.9375rem !important;
  display: inline-flex !important;
  align-items: center;
  justify-content: center;
  gap: 8px;
  background: #1a2744 !important;
  color: #fff !important;
  box-shadow: none !important;

  .anticon {
    font-size: 15px;
  }

  &:hover,
  &:focus {
    background: #243556 !important;
    color: #fff !important;
  }
`;
